<template>
  <div class="new-div">
    <div class="title-div">{{newsData.title}}</div>
    <div class="content-div">
      <div v-html="newsData.content"></div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'NewsView',
  data () {
    return {
      newsData: []
    }
  },
  created () {
    const self = this
    this.$axios.get('/cms/get/' + this.$route.params.id)
      .then(function (res) {
        self.newsData = res.data.data
      })
  }
}
</script>

<style scoped>

  .new-div {
    margin-top: 40px;
    min-height: 600px;
    text-align: center;
  }

  .title-div {
    width: 100%;
    font-size: 1.8em;
    display: inline-block;
    text-align: center;
  }

  .content-div {
    clear: both;
    text-indent: 2em;
    margin-top: 40px;
    display: inline-block;
    text-align: left;
    width: 60em;
  }

  p {
    clear: both;
    text-indent: 2em;
    width: 60em;
  }
</style>
